import {useStaticQuery, graphql} from "gatsby"

const useEventQuery = () => {
  const {allDatoCmsEvent} = useStaticQuery(graphql`
    query Event {
      allDatoCmsEvent(sort: {position: ASC}) {
        nodes {
          categories {
            title
          }
          gallery {
            ...InternalAssetProps
          }
          jsonLd
          notableFeatures {
            title
          }
          permalink
          richContent {
            value
          }
          seats
          stands
          slug
          title
          eventType
          venue {
            title
            permalink
          }
        }
      }
    }
`)

  return allDatoCmsEvent.nodes
}

export default useEventQuery